import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { ClassStudentProgressRepository } from './repositories/class-student-progress-web.repository';
import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { CLASS_STUDENT_PROGRESS_REPOSITORY } from '../core/domain';
import { CLASS_STUDENT_PROGRESS_API, ClassStudentProgressApi } from './data-sources/apis/class-student-progress.api';
export var ClassStudentProgressWebModule = /*#__PURE__*/function () {
  function ClassStudentProgressWebModule() {
    _classCallCheck(this, ClassStudentProgressWebModule);
  }

  _createClass(ClassStudentProgressWebModule, null, [{
    key: "register",
    value: function register(config) {
      var client = function client(baseUrl) {
        return new AxiosInstanceBuilder().withBaseUrl(baseUrl).withTimeout(config.timeout).withHeaders({
          Authorization: "Bearer ".concat(config.accessToken)
        }).toInstance();
      };

      return {
        module: ClassStudentProgressWebModule,
        providers: [{
          provide: CLASS_STUDENT_PROGRESS_API,
          useFactory: function useFactory() {
            return new ClassStudentProgressApi(client(config.classBaseUrl), client(config.assignmentBaseUrl));
          }
        }, {
          provide: CLASS_STUDENT_PROGRESS_REPOSITORY,
          useFactory: function useFactory(api) {
            return new ClassStudentProgressRepository(api);
          },
          inject: [CLASS_STUDENT_PROGRESS_API]
        }],
        exports: [CLASS_STUDENT_PROGRESS_REPOSITORY]
      };
    }
  }]);

  return ClassStudentProgressWebModule;
}();